module.exports = __webpack_public_path__ + "img/Redis.9e2a7e5.svg";